let inject = [
    '$scope',
    'CategoryService',
    '$state',
    '$rootScope',
    'SharedService',
    '$stateParams',
    '$uibModal',
    '$timeout',
    'CatalogService',
    'CartService',
    'SessionService'
];

class ModalConfirmationSaveItemsController {
    constructor($scope,
                CategoryService,
                $state,
                $rootScope,
                SharedService,
                $stateParams,
                $uibModal,
                $timeout,
                CatalogService,
                CartService,
                SessionService) {
        this.$state = $state;
        this.$scope = $scope;
        this.CatalogService = CatalogService;
        this.$stateParams = $stateParams;
        this.$rootScope = $rootScope;
        this.$uibModal = $uibModal;
        this.CartService = CartService;
        this.SessionService = SessionService;
        this.CategoryService = CategoryService;
        this.SharedService = SharedService;
        this.$timeout = $timeout;

        this.nameModal = "";

    }

    $onInit() {
        this.nameModal = this.mdName;

    }

}

ModalConfirmationSaveItemsController.$inject = inject;

export default ModalConfirmationSaveItemsController;




/** WEBPACK FOOTER **
 ** C:/Users/dares/Documents/SIESA_repositorios/himalaya/www/components/catalog/modal-confirmation-save-items/modal-confirmation-save-items.controller.js
 **/